import React from 'react';
import { FiShield, FiTrendingUp, FiUsers } from 'react-icons/fi';
import logoImage from '../../assets/logo-chinadolphins.png';
import css from './LeftPanel.module.css';

const features = [
  {
    icon: <FiShield />,
    title: 'Secure & Trusted',
    description: 'Enterprise-grade encryption protects your data and transactions.',
  },
  {
    icon: <FiTrendingUp />,
    title: 'Direct from China',
    description: 'Source products at factory prices with full transparency.',
  },
  {
    icon: <FiUsers />,
    title: 'All User Types',
    description: 'Built for buyers, agents, and factories on one platform.',
  },
];

const LeftPanel = () => {
  return (
    <div className={css.leftPanel}>
      {/* Decorative blobs */}
      <div className={css.blob1} />
      <div className={css.blob2} />

      

      <div className={css.content}>
        <h1>
          Welcome<br />
          <span className={css.highlight}>Back!</span>
        </h1>
        <p className={css.subtitle}>
          Your trusted bridge between global buyers and Chinese manufacturers.
        </p>

        <div className={css.featureList}>
          {features.map((item, index) => (
            <div key={index} className={css.feature}>
              <div className={css.icon}>{item.icon}</div>
              <div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className={css.statsRow}>
        <div className={css.stat}>
          <span className={css.statNum}>500+</span>
          <span className={css.statLabel}>Verified Factories</span>
        </div>
        <div className={css.statDivider} />
        <div className={css.stat}>
          <span className={css.statNum}>50+</span>
          <span className={css.statLabel}>Countries Served</span>
        </div>
        <div className={css.statDivider} />
        <div className={css.stat}>
          <span className={css.statNum}>98%</span>
          <span className={css.statLabel}>Satisfaction Rate</span>
        </div>
      </div>
    </div>
  );
};

export default LeftPanel;
